export interface UserMeta {
    survey_nps?: number
    survey_other?: number
    first_name?: string
    last_name?: string
}

export type SystemRole = "SYSADMIN" | "SYSCROWDMANAGER"

export interface APIUserModel {
    id: string
    created: string | null
    apiKey: string
    company: string
    metadata: UserMeta
    active: boolean
    email: string
    groups?: SystemRole[]
    plan: UserPlan
    username: string
    backofficeAdmin?: boolean
    trialDays?: number
}

export enum APIAppOwnerMode {
    onboarding = "ONBOARDING",
    freemium = "FREEMIUM",
    normal = "NORMAL",
    suspended = "SUSPENDED"
}

export enum UserPlan {
    "FREEMIUM" = "FREEMIUM",
    "FULL" = "FULL"
}

export const calculateFreemiumPlanExpiry = (
    user?: Pick<APIUserModel, "created" | "trialDays" | "plan">
): number | undefined =>
    user?.plan === UserPlan.FREEMIUM && user.created !== null
        ? calculateFreemiumPlanExpiryDays(user.created, user.trialDays)
        : undefined

const calculateFreemiumPlanExpiryDays = (created: string, trialDays = 7) =>
    Math.max(
        0,
        trialDays -
            Math.floor(
                (new Date().getTime() - new Date(created).getTime()) /
                    (1000 * 60 * 60 * 24)
            )
    )
